import {useEffect, useState} from 'react'
import {useContentfulClient} from './use-contentful-client.hook'
import {useIntl} from 'react-intl'
import {formatData} from '../../../utils'

export const useGetFooter = () => {
    const {locale} = useIntl()
    const [data, setData] = useState(null)
    const contentfulClient = useContentfulClient()

    useEffect(() => {
        contentfulClient
            .getEntries({
                locale,
                content_type: 'footer',
                include: 10
            })
            .then((response) => {
                const items = response?.items ?? []
                const footer = items?.at(-1)?.fields ?? null

                if (footer) {
                    const {
                        copyright = '2024 RENNAÏ © All Rights Reserved',
                        lists = [],
                        bottomActions = [],
                        socialMediaIcons = []
                    } = footer

                    setData({
                        ...footer,
                        copyright,
                        lists: lists.map((item) => formatData(item)),
                        bottomActions: bottomActions.map((item) =>
                            formatData(item)
                        ),
                        socialMediaIcons: socialMediaIcons.map((item) =>
                            formatData(item)
                        )
                    })
                }
            })
            .catch((error) => console.error('>>>> error', error))
    }, [])

    return {data}
}
